import { BusinessType } from "@/generated/graphql";

export const objToQueryString = (obj: any): string => {
  const keyValuePairs = [];
  for (const key in obj) {
    keyValuePairs.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
    );
  }
  return keyValuePairs.join("&");
};

/**
 * Check if the value is a string
 * @param value - The value to be checked
 * @returns Whether the value is a string
 */
export const isString = (value: any): value is string => {
  return typeof value === "string";
};

// fmtDate formats a date or a string containing a date in 2024年12月31日 format
export const fmtDate = (date?: string | Date): string => {
  if (!date) return "";
  date = new Date(date);
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
};

// fmtBusinessType formats a business type in Japanese
export const fmtBusinessType = (bt?: BusinessType): string => {
  switch (bt) {
    case BusinessType.Corporate:
      return "法人";
    case BusinessType.Individual:
      return "個人事業主";
    default:
      return "";
  }
};
